"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.adjudicationCommentSchema = void 0;
exports.adjudicationCommentSchema = {
    type: ['object', 'null'],
    additionalProperties: {
        not: true,
        errorMessage: '- should not have additional property ${0#}',
    },
    required: ['code', 'text', 'includeInLetterFlag', 'indexNumber', 'recordCreatedTimestamp'],
    properties: {
        code: {
            type: 'string',
            minLength: 6,
            maxLength: 7,
            errorMessage: 'Should be a string with 6 or 7 characters',
        },
        text: {
            type: 'string',
            minLength: 0,
            maxLength: 500,
            errorMessage: 'Should be a string and have maximum of 500 characters',
        },
        includeInLetterFlag: {
            type: ['boolean', 'string'],
            enum: [true, false, 'true', 'false'],
            errorMessage: 'should be true or false',
        },
        indexNumber: {
            type: 'number',
            minimum: 0,
            maximum: 2147483647,
            errorMessage: 'Should be an integer between 0 and 2147483647',
        },
        recordCreatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'Should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
    },
};
